import { useEffect, useState } from "react";

import { useMeasureParametersSelector } from "../../store";
import { IProcessedTag } from "../../store/types";

const useMeasure = (tag?: IProcessedTag) => {
  const measuresOptions = useMeasureParametersSelector();

  const [value, setValue] = useState<IProcessedTag["measure"]["id"] | null>(tag?.measure?.id || null);

  useEffect(() => {
    setValue(tag?.measure?.id || null);
  }, [tag]);

  return {
    options: measuresOptions,
    value: value,
    loading: false,
    onChange: setValue
  };
};

export default useMeasure;
